"use strict";

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Watch = void 0;

var Watch = /*#__PURE__*/function () {
  function Watch() {
    _classCallCheck(this, Watch);

    this.timestamps = new Map();
  }

  _createClass(Watch, [{
    key: "start",
    value: function start(label) {
      if (this.timestamps.has(label)) {
        throw new Error("Watch already started for label: ".concat(label));
      }

      this.timestamps.set(label, {
        started: Date.now()
      });
    }
  }, {
    key: "stop",
    value: function stop(label) {
      var timestamp = this.get(label);

      if (typeof timestamp.elapsed !== "undefined") {
        throw new Error("Watch already stopped for label: ".concat(label));
      }

      var elapsed = Date.now() - timestamp.started;
      this.timestamps.set(label, {
        started: timestamp.started,
        elapsed: elapsed
      });
    }
  }, {
    key: "get",
    value: function get(label) {
      var timestamp = this.timestamps.get(label);

      if (typeof timestamp === "undefined") {
        throw new Error("No timestamp found for label: ".concat(label));
      }

      return timestamp;
    }
  }, {
    key: "elapsed",
    value: function elapsed(label) {
      var timestamp = this.get(label);
      var elapsed = timestamp.elapsed || Date.now() - timestamp.started;
      return elapsed;
    }
  }]);

  return Watch;
}();

exports.Watch = Watch;
exports.default = Watch;